<template>
  <!-- <router-link target="_blank" :to="{name:'goodsDetail',query:{goods_id:item.id}}" class="goods-item-comp" v-if="item">
    <div class="goods-img">
      <i class="tag new-tag pos-center" v-if="tag =='new'">NEW</i>
      <i class="tag hot-tag pos-center" v-if="tag =='hot'">HOT</i>
      <img class="img-responsive" :src="item.photo" :alt="item.name" />
      <div class="add-cart pos-center">
        <button @click.stop="addCart($event)">加入購物車</button>
      </div>
    </div>
    <Score />
    <div class="goods-name">{{item.name}}</div>
    <div class="goods-item__bottom">
      <div class="goods-spac hide-on-pad">NT {{item.price1}}</div>
      <div class="favorite hide-on-pad" :class="{ active: favoriteProduct.includes(item.no) }" @click.stop.prevent="handleFavorite(item.no)"></div>
      <div class="goods-price show-on-pad">NT {{ item.price1 }}</div>
    </div>
  </router-link> -->
  <div class="goods-item-comp" v-if="item">
    <div @click="handleJumpDetail(item.id)">
      <div class="goods-img">
        <i class="tag new-tag pos-center" v-if="tag =='new'">NEW</i>
        <i class="tag hot-tag pos-center" v-if="tag =='hot'">HOT</i>
        <img class="img-responsive" :src="item.photo" :alt="item.name" />
        <div class="add-cart pos-center">
          <button @click.stop="handleOpenAddCartDrawer(item.id)">{{ $t('btns.add_cart') }}</button>
        </div>
      </div>
      <Score :score="parseFloat(item.star)"/>
      <div class="goods-name">{{item.name}}</div>
      <div class="goods-item__bottom">
        <div class="goods-spac hide-on-pad">NT {{getPrice}}</div>
        <div class="favorite hide-on-pad" :class="{ active: favoriteProduct.includes(item.id) }" @click.stop.prevent="handleFavorite(item.id)"></div>
        <div class="goods-price show-on-pad">NT {{ getPrice }}</div>
      </div>
    </div>
    
    

  </div>
</template>

<script>
import Score from "../Score";
import { mapActions,mapState } from 'vuex'
import { getGoodsDetail, addCart } from '../../api';

export default {
  props: ["tag", "item"],
  data() {
    return {
      // drawer: false,
      // choosePid: '',
      // chooseProductDetail: '',
      // direction: 'btt',
      // drawerLoading: false,
      // select: {
      //   colorIndex: 2,
      //   bustIndex: 0,
      //   sizeIndex: 3,
      // },
      // sku: {
      //   color: ["黑色", "白色", "蓝白色", "棕色"],
      //   bust: ["32", "34", "36", "38"],
      //   size: ["A", "B", "C", "D"],
      // },
      // number: 1,
    };
  },
  components: {
    Score,
  },
  computed: {
    ...mapState(['favoriteProduct','userInfo']),
    getPrice() {
      return this.item.price2 ? this.item.price2 : this.item.price1 ? this.item.price1 : this.item.price;
    }
  },
  mounted() {},
  methods: {
    ...mapActions(['handleMemberLike']),
    // async handleAddCart(e) {
    //   e.preventDefault();
    //   const postData = {
    //     store_id: this.userInfo.user.store_id,
    //     product_id: this.chooseProductDetail.id,
    //     color: this.sku.color[this.select.colorIndex],
    //     size: this.sku.size[this.select.sizeIndex],
    //     standard: this.sku.bust[this.select.bustIndex],
    //     qty: this.number,
    //     price: this.chooseProductDetail.price
    //   };

    //   await addCart(postData);

    //   this.$message({
    //     message: "加入購物車成功！",
    //     type: "success",
    //   });
    //   this.$store.commit('SET_CART_NUMBER');
    //   this.handleClose();
    // },
    async handleFavorite(id) {
      console.log('123');
      await this.handleMemberLike(id);
      console.log('456');
    },
    handleJumpDetail(id) {
      // let routeData = this.$router.resolve({ name: 'goodsDetail', query: {goods_id:id} });
      // window.open(routeData.href, '_blank');
      this.$router.push({ name: 'goodsDetail', query: {goods_id:id} });
    },
    async handleOpenAddCartDrawer(pid) {
      // this.choosePid = pid;
      // this.$refs.drawer.handleOpenAddCartDrawer(pid);
      this.$emit('addcart',pid);
    },
  },
};
</script>

<style  lang='less'>
.goods-item-comp {
  display: block;
  cursor: pointer;
  text-decoration: none;
  a {
    color: var(---unnamed-color-707070);
    text-decoration: none;
  }
  width: 255px;
  .goods-img:hover {
    .add-cart {
      position: absolute;
      top: 0px;
    }
  }
  .goods-img {
    position: relative;
    height: 350px;
    width: 100%;
    overflow: hidden;
    img {
      display: block;
    }
    .add-cart {
      cursor: pointer;
      position: absolute;
      left: 0;
      top: -600px;
      width: 100%;
      height: 100%;
      z-index: 2;
      background: rgba(255, 255, 255, 0.851);
      transition: all 0.3s;
      button {
        cursor: pointer;
        width: 125px;
        height: 40px;
        border: 1px solid var(--unnamed-color-111111);

        font-size: 13px;
        line-height: 20px;
        color: var(--unnamed-color-111111);
      }
    }
    .tag {
      position: absolute;
      left: 8px;
      top: 13px;
      width: 48px;
      height: 24px;
      background: var(--unnamed-color-111111) 0% 0% no-repeat padding-box;
      font-size: 13px;
      line-height: 20px;
      color: var(--unnamed-color-ffffff);
      text-align: left;
      font: 500 13px/20px Noto Sans SC;
      font-weight: 500;
    }

    .hot-tag {
      background: var(--unnamed-color-a72121);
    }
  }

  .goods-name {
    font-size: 16px;
    line-height: 24px;
    color: var(---unnamed-color-707070);
    letter-spacing: 1.6px;
  }
  .goods-spac {
    margin-top: 5px;
    height: 24px;

    font-size: 16px;
    line-height: 24px;
    color: var(---unnamed-color-707070);
  }
  .goods-item__bottom {
    margin-top: 6px;
    margin-bottom: 35px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .favorite {
    width: 24px;
    height: 24px;
    background: url("./images/favorite_border-24px@2x.png") no-repeat;
    background-size: contain;
    background-position: center center;
  }
  .favorite:hover {
    background: url("./images/941@2x.png") no-repeat;
    background-size: contain;
    background-position: center center;
  }
  .favorite.active {
    background: url("./images/943@2x.png") no-repeat;
    background-size: contain;
    background-position: center center;
  }
  @media (max-width: 992px) {
    flex: 0 0 50%;
    margin-right: 0 !important;
    // padding: 0 15px;
    .goods-img {
      height: unset !important;
      padding-top: calc(100%/153*191);
      position: relative;
      img {
        position: absolute;
        top: 0;
        left: 0;
      }
    }
    .score {
      display: flex;
      justify-content: center;
    }
    .goods-name {
      text-align: center;
      font-size: 0.8rem;
      line-height: 1rem;
    }
    .goods-item__bottom {
      margin-bottom: 20px;
      color: var(---unnamed-color-707070);
      justify-content: center;
      .goods-price {
        font-size: 1.5rem;
        font-weight: 400;
      }
    }
  }
}
</style>
